module.exports = __webpack_public_path__ + "static/media/fcpsr.6a8ee2c6.svg";